import React from 'react';
import PropTypes from 'prop-types';
import { Link, utils } from '@resy/ui-kitchen';
import './AmexGDAFeaturedCard.scss';
import { CTA_EVENT_NAME } from '../../../AmexMarketingUtils/constants';
import { handleMktAnalytics } from '../../../AmexMarketingUtils/AmexUtils';

const AmexGDAFeaturedCard = ({
  restaurant, bookNowLinkText, noBookNowText, Analytics,
}) => {
  const { priceRangeToString } = utils;

  const onClickTagging = (restaurantName) => {
    const extraParam = {
      action_name: 'Featured Restaurants - Venue Click',
      item_name: restaurantName,
    };
    handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParam);
  };

  const cardContent = () => (
    <>
      <div
        className="GDA__FeaturedCard--image"
        style={{
          backgroundImage: `url(${restaurant.image})`,
        }}
      />
      <h3 className="GDA__FeaturedCard--name">{restaurant.name}</h3>
      <p className="GDA__FeaturedCard--features">
        {restaurant.cuisine}
        &nbsp;&middot;&nbsp;
        {restaurant.city_name}
        &nbsp;&middot;&nbsp;
        {priceRangeToString(restaurant.price_range, restaurant.currency)}
      </p>
      <p className="GDA__FeaturedCard--features--mobile">
        {restaurant.cuisine}
        <br />
        {restaurant.city_name}
        &nbsp;&middot;&nbsp;
        {priceRangeToString(restaurant.price_range, restaurant.currency)}
      </p>
      {restaurant.bookNowLink && (
        <p className="GDA__FeaturedCard--booknowlink">
          {bookNowLinkText}
        </p>
      )}

      {restaurant.venue_url && (
        <p className="GDA__FeaturedCard--booknowlink">
          {restaurant.venue_url_text}
        </p>
      )}

      {(!restaurant.venue_url && !restaurant.bookNowLink) && (
        <p className="GDA__FeaturedCard--booknowEmpty">
          {noBookNowText}
        </p>
      )}
    </>
  );

  let linkToClick = '';
  // eslint-disable-next-line camelcase
  const { bookNowLink = '', venue_url = '' } = restaurant;
  if (bookNowLink) linkToClick = bookNowLink;
  // eslint-disable-next-line camelcase
  else if (venue_url) linkToClick = venue_url;
  if (linkToClick) {
    return (
      <div className="GDA__FeaturedCard">
        <Link
          target="_blank"
          href={linkToClick}
          rel="noopener noreferrer"
          onContextMenu={() => onClickTagging(restaurant.name)}
          onClick={() => onClickTagging(restaurant.name)}
        >
          {cardContent()}
        </Link>
      </div>
    );
  }

  return (
    <div className="GDA__FeaturedCard">
      <div>
        {cardContent()}
      </div>
    </div>
  );
};

AmexGDAFeaturedCard.defaultProps = {
  restaurant: {},
  bookNowLinkText: '',
  noBookNowText: '',
};

AmexGDAFeaturedCard.propTypes = {
  restaurant: PropTypes.shape({
    id: PropTypes.number,
    image: PropTypes.string,
    name: PropTypes.string,
    cuisine: PropTypes.string,
    city_name: PropTypes.string,
    price: PropTypes.string,
    bookNowLink: PropTypes.string,
    price_range: PropTypes.number,
    currency: PropTypes.string,
    venue_url: PropTypes.string,
    venue_url_text: PropTypes.string,
  }),
  bookNowLinkText: PropTypes.string,
  noBookNowText: PropTypes.string,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};

export default AmexGDAFeaturedCard;
